module.exports = __webpack_public_path__ + "static/media/caret.688a1471.svg";